import { decodeHtml } from '../decodeHtml';
import { isString } from '../isString';

export function decodeHtmlInObject(obj) {
  return obj && Object.keys(obj).reduce((previousValue, currentValue) => {
    previousValue[currentValue] = isString(obj[currentValue])
      ? decodeHtml(obj[currentValue])
      : obj[currentValue];

    return previousValue;
  }, {}) || {};
}
